import { render } from "./NewPageTraining.vue?vue&type=template&id=06b52503&scoped=true"
import script from "./NewPageTraining.vue?vue&type=script&lang=js"
export * from "./NewPageTraining.vue?vue&type=script&lang=js"

import "./NewPageTraining.vue?vue&type=style&index=0&id=06b52503&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b52503"]])

export default __exports__